import styled from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
`

export const Container = styled.div`
    margin: 0rem 0.5rem;
    width: 95%;
    display: flex;
    flex-direction: column;
    overflow: scroll;

    &::-webkit-scrollbar{
        display: none;
    }

    table{
        border-collapse: collapse;
        border-radius: 10px;
        margin: 25px 0;
        color: var(--colorFontsCardsDashboard);

        thead{
            background: var(--colorBackgroundCardsDashboard);
            position: relative;
            tr{
                text-align: left;
                
                th{
                    div{
                        display: flex;
                        align-items: center;

                        svg{
                            margin-left: 5px;
                        }
                    }

                    font-size: 17px;
                    text-align: left;

                    @media(max-width: 800px){
                        font-size: 15px;
                    }

                    @media(max-width: 700px){
                        font-size: 13px;
                    }
                }
            }
        }

        tbody{
            tr{
                text-align: left;
                border-bottom: 1px solid #ddd;

                td:first-child{
                    width: 10px;
                }
    
                &:nth-child(even){
                    background: #f3f3f3;
                }

                td {
                    background: transparent;
                    border: none;
                    color: #535354; 
                    
                    .button{
                        background: transparent;
                        border: none;
                        font-size: 1.2rem;
                        color: #535354;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    }
                }
            }
        }

        th, td{
            padding: 0.15rem 0.35rem;
            font-size: 15px;
            height: 40px;

            @media(max-width: 800px){
                font-size: 13px;
            }

            @media(max-width: 700px){
                font-size: 12px;
            }
          
        } 
    }
`